import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { singleOrderDetails } from '../../../../../../@store/orders/orders.model';
import { SingleCaNumberDetails } from '../../../../../../@store/products/ca-numbers/ca-numbers.model';

@Component({
  selector: 'ciwc-order-specification-display',
  imports: [CommonModule],
  standalone: true,
  templateUrl: './order-specification-display.component.html',
  styleUrl: './order-specification-display.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderSpecificationDisplayComponent {
  @Input() parentForm!: FormGroup;
  @Input() details!: SingleCaNumberDetails;
  @Input() orderDetails!: singleOrderDetails;

  getFormValue(controlName: string): string {
    const value = this.parentForm?.get(controlName)?.value;
    return value || '';
  }

  getDetailValue(property: keyof SingleCaNumberDetails): string {
    if (!this.details) return '';
    const value = this.details[property];
    return value ? String(value) : '';
  }
}
